import { render, staticRenderFns } from "./ProductDepartment.vue?vue&type=template&id=55fdb09e&scoped=true&"
import script from "./ProductDepartment.vue?vue&type=script&lang=js&"
export * from "./ProductDepartment.vue?vue&type=script&lang=js&"
import style0 from "./ProductDepartment.vue?vue&type=style&index=0&id=55fdb09e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fdb09e",
  null
  
)

export default component.exports